
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rbc",
      function () {
        return require("private-next-pages/rbc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rbc"])
      });
    }
  